
<template>

  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
    <h5 class="card-title" >미국학습<div class="sub_title" >학습관리 → 숙제관리 → 미국학습 </div></h5>
      <h6 style="text-align:left; margin-top:10px; ">
        조회하고자 하는 클래스 및 기타 정보를 통해 학습현황을 조회할 수 있습니다.<br />
        학생리스트가 많을수록 조회시간이 길어질 수 있습니다.
      </h6>
      <query-grid :config="config" ref="qg">
        <template #actions>
          <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="Getclasslist(true)">미국학교 숙제부여</button>
        </template>
        <template #resultactions>
        <button class="btn btn-secondary" @click="batchDelete()">일괄 Delete</button>
        </template>
        <template #items="props">
          <tr v-for="(record, i) in props.records" v-bind:key="record.intHWNo">
            <td scope="col"><input type="checkbox" v-model="record.checked"></td>
            <td style="text-align:center;" v-if="this.$root.guiPerm != 'CLASS' && this.$root.guiPerm != 'ENTERPRISE'" >
                <Business v-if="record.t2" :biz="record.t2" /></td>
            <td style="text-align:center;"> <Business v-if="record.t1" :biz="record.t1" /></td>
            <td style="text-align:center;">{{ record.username }}</td>
            <td style="text-align:center;">{{ record.name }}</td>
            <td style="text-align:center;">{{ record.datAssign.substr(2, 8) }}</td>
            <td style="text-align:center;"><span v-if="record.datEnd">{{ record.datEnd.substr(0, 10) }}</span></td>
            <td style="text-align:center;">{{ record.strGrade }}</td>
            <td style="text-align:center;">{{ record.strCourse }}</td>
            <td style="text-align:center;">{{ record.strSubject }}</td>
            <td style="text-align:center;">~ {{ record.strDay }} DAY</td>
            <td style="text-align:center;">
              <template v-if="record.chrDone">
                <button class="btn btn-info btn-sm" style="line-height:14px;">Complete<br>{{record.datDone.substr(0, 16)}}</button>

              </template>
              <template v-else>
                <button class="btn btn-danger btn-sm" @click="DelCurrent(record.intHWNo)">Delete</button>
              </template>
            </td>
          </tr>
        </template>
      </query-grid>



<!-- 미국학교 숙제부여 modal -->
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-modal="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">미국학교 숙제부여</h5>
            </div>
            <div class="modal-body">

           <table class="table">
               <colgroup>
               <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
                   <col style="width:25%;">
               </colgroup>
             <tbody>
               <tr>
                 <th>숙제부여</th>
                 <td colspan="3" style="text-align:left;">


                      <select v-model="classselected" class="custom-select flex_center" style="width:170px;display:inline; margin:0 4px;  background:#f0fbff;" @change="viewStudent()">
                          <option disabled value="">Please select one</option>
                          <option v-for="classlist in classlists" :value="classlist.id">
                            {{ classlist.name }}
                          </option>
                        </select>
                        <select v-model="customValue" class="custom-select flex_center" style="width:100px;display:none;">
                          <option :value="0">ALL</option>
                          <option :value="1">개인별</option>
                        </select>
                        <input type="checkbox"
                                v-model="allChecked"
                                @click="checkedAll($event.target.checked)"
                        > 전체선택


                 </td>
               </tr>
               <tr>
                 <td colspan="4"><div class="select_homework" style="text-align:left;">
                   <ul v-if="customValue == '1'">
                    <li v-for="(studentlist, index) in studentlists" :value="studentlist.id">
                      <input type="checkbox" name='tmpChkbox[]' :value="index" style="vertical-align:top;" v-model="studentlist.selected" @change="selected($event)"/>{{studentlist.name}}&nbsp;
                      <span style="font-size:11px;line-height:1px; padding:3px 6px; background:#00acea; color:#fff; border-radius:4px;">{{studentlist.level}}</span></li>
                  </ul>
                 </div>

                 </td>
               </tr>
               <tr>
                 <th>부여범위</th>
                 <td colspan="3" style="text-align:left;">
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" @change="onChangeSGrade(true)" v-model="sslevel">
     <option value="">Grade</option>
<option value="GK">GK</option>
                    <option value="GK_1">GK_1</option>
                    <option value="GR1">GR1</option>
                    <option value="GR2">GR2</option>
                    <option value="GR3">GR3</option>
                    <option value="GR4">GR4</option>
                    <option value="GR5">GR5</option>
   </select>
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" @change="onChangeSCourse(true)" v-model="ssCourse">
     <option value="">Grade_2</option>
    <option v-for="strCourse in sstrCourses" v-bind:key="strCourse.strCourse">
      {{ strCourse.strCourse }}</option>
  </select>
  <select class="custom-select flex_center" v-model="ssSubject" style="width:120px;display:inline; margin:0 4px;" @change="onChangeSSubject(true)">
    <option value="">Subject</option>
    <option v-for="strSubject in sstrSubjects" v-bind:key="strSubject.strSubject">
      {{ strSubject.strSubject }}</option>
  </select>
   <select class="custom-select flex_center" style="width:100px;display:inline; margin:0 4px;" v-model="ssday" >
    <option value="">Day</option>
    <option v-for="(intTot, index) in sstrdays.intTime" :value="index + 1">
      ~&nbsp;{{ index + 1 }} DAY
    </option>

   </select>
</td>
               </tr>
               <tr>
                 <th>시작일</th>
                 <td style="text-align:left;">  <input v-model="datAssign" type="date" style="width:140px; margin:0 4px;" /></td>
                 <th>종료일</th>
                 <td style="text-align:left;"><input v-model="datEnd" type="date" style="width:140px; margin:0 4px;" /></td>
               </tr>
               <tr>
                 <td colspan="4"><button class="btn btn-danger" data-bs-toggle="modal" data-bs-target=".bd-example-modal-lg" @click="PutCurrent(true)">미국학교 숙제부여</button></td>
               </tr>
             </tbody>
           </table>

           <p style="font-size:14px;">
           - <span style="font-weight:bold;">학생과정과 부여한 숙제과정이 다른 경우</span>에는 숙제를 수행할 수 없습니다.<br />
           - 일괄 숙제부여시에는 반드시 반 학생들의 레벨 및 차시를 확인후 부여해주세요.<br />
           - 기간이 지난 숙제의 경우 <span style="font-weight:bold;">기간후에 숙제를 완료해도 미완료(incomplete)</span>로 처리됩니다.<br />
           - 숙제부여후 <span style="font-weight:bold;">레벨을 변경하게 되면 해당 숙제는 기간이 남아 있어도 숙제기록실(Homework history)로 이동</span>하게 됩니다.<br />
           - 일괄부여의 경우는 해당반 학생들이<span style="font-weight:bold;"> 모두 동일레벨, 동일 차시일 경우</span>에만 사용해주시기 바랍니다.<br />
           </p>

            </div>
            <div class="modal-footer" style="border-top:none;">



                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
            </div>
        </div>
    </div>
</div>



      </div>
    </div>
  </div>


</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import TreeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import Student from "../components/detail_pages/Student"
import axios from "axios";
export default {
  name: 'Home',
  components: {
    Tree,
    TreeBtn,
    Business,
    Student,
    QueryGrid
  },
  mounted(){
    if(this.$root.guiPerm == 'CLASS' || this.$root.guiPerm == 'ENTERPRISE'){
        this.config.columns.splice(1, 1);
      }
    this.$refs.qg.search()
  },
  methods: {
              toggleAllChecks(){
            var to = null;
            var status = this.getAllCheckStatus();
            if(status <= 0){
              to = true;
            } else {
              to = false;
            }
            this.updateAllChecks(to);
          },
        updateAllChecks(status){
          this.records.filter(v => !v.chrDone).forEach((v) => {
            v.checked = !!status;
          })
        },
                getAllCheckStatus(){
          var checks = this.records.filter(v => !v.chrDone).map(x => x.checked || false);
          console.log(checks)
          if(!checks.includes(true)){
            console.log(-1)
            return -1;
          } else if(!checks.includes(false)) {
            console.log(1)
            return 1;
          } else {
            console.log(0)
            return 0;
          }
        },
      selectedSearchBiz(biz) {
      //console.log(biz)
      this.searchBiz = biz;
      this.$refs.qg.search();
    },
    search(reset){
      if(reset) this.offset=0;
      var extras = "?limit=15&offset=" + this.offset
      if(this.searchBiz && this.searchBiz){
        extras += "&business=" + JSON.stringify(this.searchBiz)
      }
      if(this.searchKeyword){
        extras += "&search=" + this.searchKeyword
      }
      if(this.slevel){
        extras += "&slevel=" + this.slevel
      }
      if(this.sCourse){
        extras += "&sCourse=" + this.sCourse
      }
      if(this.sSubject){
        extras += "&sSubject=" + this.sSubject
      }
      if(this.sStatus){
        extras += "&sStatus=" + this.sStatus
      }
      if(this.date_filter){
        extras += "&date_filter=" + this.date_filter
        if(this.date_filter_start){
          extras += "&date_filter_start=" + this.date_filter_start
        }
        if(this.date_filter_end){
          extras += "&date_filter_end=" + this.date_filter_end
        }
      }
      axios.get('/studies/americanList' + extras).then((response) => {
                  if(response.data.error){
                                        $.notify({
                    // options
                    message: '데이터를 조회할 수 없습니다. ' + response.data.error
                    }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                    });
                  } else {
                    this.records = response.data.result;
                    this.total = response.data.total;
                    //console.log(this.records);
                  }


                })
    },
    GetDetail(intHWNo, b1){
      //console.log(intHWNo);
      axios.get('/homework/ameraca_detail/' + intHWNo).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            console.log(response.data.slist);
            this.details = response.data.result;
            this.students = response.data.slist;
            this.sb1 = b1;
          }
        })
    },
    onChangeGrade(reset){
      axios.get('/studies/gradelist/' + this.slevel).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.strCourses = response.data.result;
            this.sCourse = "";
            this.sSubject = "";
            console.log(response.data.result);
          }
        })
    },
    onChangeSGrade(reset){
      if(this.sslevel){
        axios.get('/studies/gradelist/' + this.sslevel).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.sstrCourses = response.data.result;
              this.sstrSubjects = "";
              this.sstrdays = "";
              this.ssCourse = "";
              this.ssSubject = "";
              this.ssday = "";
              console.log(response.data.result);
            }
        })
        }
        else{
          this.sstrCourses = "";
          this.sstrSubjects = "";
          this.sstrdays = "";
          this.sstrCourses = "";
          this.ssSubject = "";
          this.ssday = "";
        }
    },
    onChangeCourse(reset){
      axios.get('/studies/courselist/' + this.sCourse).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.strSubjects = response.data.result;
            this.sSubject = "";
            console.log(response.data.result);
          }
        })
    },
    onChangeSCourse(reset){
      if(this.ssCourse){
      axios.get('/studies/courselist/' + this.ssCourse).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.sstrSubjects = response.data.result;
            this.ssSubject = "";
            this.sstrdays = "";
            this.ssday = "";
            console.log(response.data.result);
          }
        })
      }
      else{
        this.sstrSubjects = "";
        this.sstrdays = "";
        this.ssSubject = "";
        this.ssday = "";
      }
    },
    onChangeSSubject(reset){
      if(this.ssSubject){
        axios.get('/studies/daylist/' + this.ssCourse + '/' + this.ssSubject.replaceAll('/','_')).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.sstrdays = response.data.result;
              this.ssday = "";
              console.log(response.data.result);
            }
          })
      }
      else{
        this.sstrdays = "";
        this.ssday = "";
      }
    },
    Getclasslist(reset){

      axios.get('/homework/languages_add').then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.classlists = response.data.classlist;
          }
        })

      var today = new Date();

      var year = today.getFullYear();
      var month = ('0' + (today.getMonth() + 1)).slice(-2);
      var day = ('0' + today.getDate()).slice(-2);

      var dateString = year + '-' + month  + '-' + day;

      if(!this.datAssign){
        this.datAssign = dateString;
      }

      if(!this.datEnd){
        this.datEnd = dateString;
      }
    },
    viewStudent(){
      //console.log(this.classselected);
      axios.get('/homework/students/' + this.classselected).then((response) => {
          if(response.data.error){
                                $.notify({
            // options
            message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
            // settings
            type: 'danger',
            z_index: 9999
            });
          } else {
            this.studentlists = response.data.result;
            this.stotal = response.data.total;
            this.allChecked = false;
          }


        })
    },
    DelCurrent(intHWNo, skipSearch) {
      return new Promise((resolve) => {
      axios.post('/studies/americanDelete', {
        'intHWNo': intHWNo
      }).then((response) => {
        resolve()
        if (response.data.error) {
          $.notify({
            // options
            message: '데이터를 삭제할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          $.notify({
            // options
            message: '삭제되었습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          if(!skipSearch) this.$refs.qg.search()
        }
      })
      })
    },
    batchDelete(){
      var prom = [];
      this.$refs.qg.checked.forEach(element => {
        //if(element.checked){
          prom.push(this.DelCurrent(element.intHWNo, true));
        //}
      });
      Promise.all(prom).then(() => {
        this.$refs.qg.search()
      })
    },
    checkedAll(checked) {
        this.allChecked = checked;
        for (let i in this.studentlists) {
              this.studentlists[i].selected = this.allChecked;
          }
    },
    selected (e) {
        for (let i in this.studentlists) {
            if(! this.studentlists[i].selected) {
                this.allChecked = false;
                return;
            } else {
                this.allChecked = true;
            }
        }
    },
    PutCurrent(reset){

      if(!this.classselected){
        $.notify({
          // options
          message: '부여할 클래스를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      var tmpVal = [];
      var temStu = [];

      var strLevel = "";
      var intSu = 0;
      var notSu = 0;
      var strmessage = "";
      var strNotmessage = "";

      if(!this.sslevel){
        $.notify({
          // options
          message: '부여할 Grade를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      strLevel = this.sslevel;

      if(this.customValue){

        temStu = this.studentlists;

        $("input[name='tmpChkbox[]']:checked").each(function() {

          if(strLevel == temStu[$(this).val()].level){
            tmpVal.push(temStu[$(this).val()].id);
            intSu = intSu + 1;
          }
          else{
              notSu = notSu + 1;
          }

        });

        if(intSu == 0){
          if(notSu == 0){
            strmessage = '부여할 학생을 선택하셔야 합니다. '
          }
          else{
            strmessage = 'Grade가 맞지 않아 부여할 수 없습니다. '
          }
        }

        console.log(tmpVal.length);
        //return;

        if(tmpVal.length == 0){
          $.notify({
            // options
            message: strmessage
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }

      }



      if(!this.ssCourse){
        $.notify({
          // options
          message: '부여할 Grade_2를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      if(!this.ssSubject){
        $.notify({
          // options
          message: '부여할 Subject를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }

      if(!this.ssday){
        $.notify({
          // options
          message: '부여할 Day를 선택하셔야 합니다. '
        }, {
          // settings
          type: 'danger',
          z_index: 9999
        });
        return;
      }
      console.log(notSu);

      axios.post('/studies/amehomesave', {
        'strGrade': this.sslevel,
        'strCourse': this.ssCourse,
        'strSubject': this.ssSubject,
        'sDay': this.ssday,
        'tmpVal': tmpVal,
        'classselected': this.classselected,
        'customValue': this.customValue,
        'tmpVal': tmpVal,
        'datAssign': this.datAssign,
        'hopeStop': this.datEnd
      }).then((response) => {
        if (response.data.error) {
          $.notify({
            // options
            message: '숙제를 부여 할 수 없습니다. ' + response.data.error
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
        } else {
          console.log(response.data.result);

          if(notSu >0){
            strNotmessage = '숙제를 부여하였습니다. ' + notSu + '명의 학생은 Grade가 맞지 않아 부여 할 수 없습니다.'
          }
          else{
            strNotmessage = '숙제를 부여하였습니다.'
          }

          $.notify({
              // options
            message: strNotmessage
          }, {
            // settings
            type: 'success',
            z_index: 9999
          });
          this.$refs.qg.search(true);
        }
      })

    }
  },
  data(){
    return {
      config: {
      "name": "미국학교 숙제",
      "req_endpoint": "/studies/americanList_new",
      "default_limit": 20,
      "search_fields": [
          {
              "id": "businesses",
              "name": "소속선택",
              "type": "business" // business, date, datetime,
          },
          {
              "id": "date_filter",
              "name": "날짜검색",
              "type": "date",
              "filter_type": {
                  "created_at": "시작일",
                  "end_date": "종료일"
              }
          },
          {
              "id": "grade_filter",
              "name": "학습단계",
              "type": "switch",
              "filter_type": {
                  "GK": "GK",
                  "GK_1": "GK_1",
                  "GR1": "GR1",
                  "GR2": "GR2",
                  "GR3": "GR3",
                  "GR4": "GR4",
                  "GR5": "GR5"
              }
          },
          {
              "id": "step_filter",
              "name": "스텝단계",
              "type": "switch",
              "filter_type": {
                  "GK001": "GK001",
                  "GK002": "GK002",
                  "GK003": "GK003",
                  "GK004": "GK004",
                  "GK005": "GK005",
                  "GK001_1": "GK001_1",
                  "GK002_1": "GK002_1",
                  "GK003_1": "GK003_1",
                  "GK004_1": "GK004_1",
                  "GK005_1": "GK005_1",
                  "GR101": "GR101",
                  "GR102": "GR102",
                  "GR103": "GR103",
                  "GR104": "GR104",
                  "GR105": "GR105",
                  "GR106": "GR106",
                  "GR201": "GR201",
                  "GR202": "GR202",
                  "GR203": "GR203",
                  "GR204": "GR204",
                  "GR205": "GR205",
                  "GR206": "GR206",
                  "GR301": "GR301",
                  "GR302": "GR302",
                  "GR303": "GR303",
                  "GR304": "GR304",
                  "GR401": "GR401",
                  "GR402": "GR402",
                  "GR403": "GR403",
                  "GR404": "GR404",
                  "GR501": "GR501"
              }
          },
          {
              "id": "Subject_filter",
              "name": "과목",
              "type": "switch",
              "filter_type": {
                  "Language Arts": "Language Arts",
                  "plus": "Language Arts_plus",
                  "Math": "Math",
                  "Science": "Science",
                  "Social Studies ": "Social Studies",
                  "MA/SS/SC": "MA/SS/SC"
              }
          },
          {
              "id": "status_filter",
              "name": "수행여부",
              "type": "switch",
              "filter_type": {
                  "FINISH": "완료",
                  "ING": "미완료"
              }
          },
          {
              "id": "search",
              "name": "키워드검색",
              "type": "text",
              "placeholder": "본부/학원/클래스/이름으로 검색"
          }
      ],
      "columns": [
          {
              "id": "chkbox",
              "name": "체크",
              "is_check": true,
              "excel_print": false
          },
          {
              "id": "biz",
              "name": "Campus",
              "excel_print": v=>{return v.t2.name}
          },
          {
              "id": "Class",
              "name": "Class",
              "excel_print": v=>{return v.t1.name}
          },
          {
              "id": "ID",
              "name": "ID",
              "excel_print": v=>{return v.username}
          },
          {
              "id": "Name",
              "name": "Name",
              "excel_print": v=>{return v.name}
          },
          {
              "id": "Assigned Date",
              "name": "Assigned Date",
              "excel_print": v=>{return v.datAssign.substr(2, 8)}
          },
          {
              "id": "Due Date",
              "name": "Due Date",
              "excel_print": v=>{return v.datEnd ? v.datEnd.substr(0, 10) : ''}
          },
          {
              "id": "Grade",
              "name": "Grade",
              "excel_print": v=>{return v.strGrade}
          },
          {
              "id": "Step",
              "name": "Step",
              "excel_print": v=>{return v.strCourse}
          },
          {
              "id": "Subject",
              "name": "Subject",
              "excel_print": v=>{return v.strSubject}
          },
          {
              "id": "Homework",
              "name": "Homework",
              "excel_print": v=>{return '~' + v.strDay + 'Day'}
          },
          {
              "id": "Result",
              "name": "Result",
              "excel_print": v=>{return v.chrDone ? 'Complete' + v.datDone.substr(0, 16) : ''}
          }
      ],
      disable_init_search: true
  },
      records: [],
      searchKeyword: "",
      searchBiz: "",
      offset: 0,
      total: 0,
      soffset: 0,
      index: 0,
      slevel: "",
      sCourse: "",
      sSubject: "",
      sStatus: "",
      strCourses: "",
      classlists: [],
      studentlists: [],
      customValue: '1',
      strSubjects: "",
      sstrSubjects: "",
      sstrdays: "",
      sslevel: "",
      ssCourse: "",
      ssSubject: "",
      ssday: "",
      details: "",
      sstrCourses: "",
      allChecked: false
    }
  },
        computed: {
              checked: function(){
        return this.records.filter(record => record.checked && !record.chrDone);
      }
      }
}
</script>
